module.exports = __webpack_public_path__ + "img/list-completed.e14ab7c9.svg";